<template>
  <div class="position-relative">
    <input v-model="search" :placeholder="placeholder" style="height:32px;border:1px solid grey;border-radius: 3px;width: 100%"/>
    <div v-show="items.length>0"
         style="position: absolute;border-bottom:1px solid gray;top: 32px;width: 100%;z-index: 100000;background: #e3e3e3;max-height: 150px;height: fit-content;min-height: 40px;overflow: auto">
      <div v-for="item in items" @click="select_item(item)" style="cursor: pointer;padding: 2px">
        {{ item.productCodeName }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'AutocompleteSearchProduct',
  slots: [],

  components: {},

  data() {
    return {
      search: '',
      items: [],
      placeholder:"جستجو کالا",
      self: null
    }
  },
  computed: {},
  watch: {
    'search': function () {
      this.load_products()
    }
  },
  mounted() {
    axios.defaults.baseURL = localStorage.getItem("api_address");
  },
  methods: {
    select_item(item) {

      this.$emit('input', item.id)
      this.$emit('select', item);
      this.placeholder=item.productCodeName
this.items=[]
      this.search=""
    },
    load_products() {
      var self = this
      if (this.search.length <= 2) {
        this.items = []
        return
      }
      const formData = new FormData();

      formData.append('SearchTxt', this.search);
      if (this.document_person != null) {
        formData.append('PersonId', this.document_person);
      }

      axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
        self.items = response.data.data
      })
          .catch(function (error) {
            console.log(error);
          });

    },
  },


}
</script>
